import * as React from "react"
import { IconProps } from "./utils"

export function MDXIcon({ height = 24, width = 24 }: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 78 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M75.0327 1H2.96743C1.5627 1 0.42395 2.13875 0.42395 3.54348V29.8261C0.42395 31.2308 1.5627 32.3696 2.96743 32.3696H75.0327C76.4374 32.3696 77.5761 31.2308 77.5761 29.8261V3.54348C77.5761 2.13875 76.4374 1 75.0327 1Z"
        fill="white"
        stroke="#EAEAEA"
        strokeWidth="0.847826"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.5435 6.70081V19.6345L46.294 14.8844L48.6919 17.2825L39.9105 26.0632L31.0184 17.1711L33.4164 14.7731L38.1522 19.5088V6.70081H41.5435ZM26.6963 7.15623V25.3038H23.305V15.3431L17.126 21.5217L10.9935 15.3888V25.405H7.60217V7.20103L17.1262 16.7257L26.6963 7.15623Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.4416 15.7406L70.4037 22.7025L68.0058 25.1005L61.0436 18.1386L54.0814 25.1005L51.6834 22.7025L58.6455 15.7406L51.4624 8.55772L53.8604 6.15967L61.0436 13.3426L68.2268 6.15967L70.6247 8.55772L63.4416 15.7406Z"
        fill="#F9AC00"
      />
    </svg>
  )
}
